"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkRebrand = void 0;
var checkRebrand = exports.checkRebrand = function checkRebrand(rebrand, original) {
  return localStorage.getItem('rebranding') === 'true' ? rebrand : original;
};